const translations = {
  "en": {
    "selected": "selected"
  },
  "zh-tw": {
    "selected": "已選擇"
  }
};

export default translations;
